import ExternalNewsView from '@package/components/View/ExternalNewsView';

export const SiteViews = (config) => {
  config.views.contentTypesViews.ExternalNews = ExternalNewsView;
  delete config.views.contentTypesViews['News Item']; //usa la view del Document (pagina)
  delete config.views.contentTypesViews['Event']; //usa la view del Document (pagina)
};

export default SiteViews;
